import { Icon } from "@iconify/react";

const IconButton = ({
  variant,
  label,
  className,
  size,
  icon,
  iconDirection,
  disabled,
  loading,
  onClick,
}) => {
  const getButtonClassNames = () => {
    let baseClassName =
      "flex flex-col items-center justify-center transition-all duration-300 ";
    switch (variant) {
      case "primary":
        baseClassName += "bg-primary-gradient text-white ";
        break;
      case "secondary":
        baseClassName += "bg-white ";
        break;
      case "outline-primary":
        baseClassName += "border-[1.5px] border-border-primary ";
        break;
      case "outline-dark-blue":
        baseClassName +=
          "border-[1.5px] border-[#2734771A] hover:shadow-[2px_2px_5px_0_rgba(0,_0,_0,_0.25)] ";
        break;
      case "secondary-blur":
        baseClassName += "border border-secondary-blur-01 ";
        break;
      case "dark":
        baseClassName += "bg-black text-white ";
        break;
      case "white-blur":
        baseClassName +=
          "bg-white-blur-02 text-white hover:bg-white hover:text-[#0F172A] ";
        break;
      case "transparent-white":
        baseClassName += "bg-transparent border border-white text-white ";
        break;
    }
    baseClassName += className ? ` ${className} ` : "";
    return baseClassName;
  };

  const getIconClassNames = () => {
    let baseClassName = "lg:w-5 lg:h-5 w-4 h-4";

    switch (variant) {
      case "secondary":
        baseClassName += "";
        break;
    }

    return baseClassName;
  };

  return (
    <button className={getButtonClassNames()} onClick={onClick}>
      <Icon icon={icon} className={getIconClassNames()} />
    </button>
  );
};

export default IconButton;
